module.exports = __webpack_public_path__ + "static/media/Sudowoodo_gaussian2.d65003d7.png";